<template>
  <div class="rating d-flex">
    <div class="d-flex flex-column text-center mr-3">
        <span class="rating-number">{{ parseFloat(sentiment.overallRating / 10).toFixed(1) }}</span>
        <span class="rating-explain">Out of 10</span>
    </div>
    <div class="d-flex flex-column">
        <span class="rating-text" v-if="sentiment.overallRating > 80">
            Excellent
        </span>
        <span class="rating-text" v-else-if="sentiment.overallRating > 60">
            Good
        </span>
        <span class="rating-text" v-else-if="sentiment.overallRating > 40">
            Fair
        </span>
        <span class="rating-text" v-else-if="sentiment.overallRating > 20">
            Poor
        </span>
        <span class="rating-text" v-else-if="sentiment.overallRating > 0">
            Bad
        </span>
        <div class="rating-count">{{ sentiment.numberOfRatings }} ratings</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rating',
  props: {
        sentiment: {
            type: Object,
            required: true
        }
    },
  components: {
  
  }
}
</script>

<style scoped>
    .rating-number{
        font-size: 2.5rem;
        font-weight: bold;
        line-height: 2rem;
        color:#0040C1;
    }
    .rating-explain{
        font-size:0.7rem;
        font-weight:bold;
        color:#888;
    }
    .rating-text{
        font-size:1rem;
        font-weight:bold;
    }
    .rating-count{
        font-size:0.7rem;
    }
</style>